
<div class="card">
    <div class="card-header">
        <h4>Add Commission Profile</h4>
    </div>
    <div class="row">
        <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item" role="presentation">
                <a class="nav-link" [class.active]="activeTab === 'service'">Basic Information</a>
            </li>
            <li class="nav-item" role="presentation">
                <a class="nav-link" [class.active]="activeTab === 'commission'">Commission Setup</a>
            </li>
          </ul>
    </div>

    <div class="tab-content pt-2" id="myTabContent">
         <div id="service" class="tab-pane fade p-4 active show" [ngStyle]="{ 'display': activeTab === 'service'? 'block' : 'none'}">
          <form #editCommissionprofile="ngForm" (ngSubmit)="editCommissionProfile(editCommissionprofile.value)" [formGroup]="editCommissionProfileForm">
            <div class="row">
                <div class="col-lg-12">
                  <div class="card border-0 shadow-none text-center">
                    <div class="card-body">
                      <div class="row d-flex">
                        <div class="form-group col-md-4">
                          <label class="col-form-label" for="commissionProfileName">Commission Profile Name <span aria-hidden="true"
                                  class="symbol required" style="color:red;">*</span>
                          </label>
                          <input type="text" id="commissionProfileName" readonly class="form-control" required formControlName="commissionProfileName" [ngClass]="{'is-invalid':submitted && editCommissionProfileForm.controls.commissionProfileName.errors}"  name="commissionProfileName">
                        </div>
                        <div class="form-group col-md-4">
                          <label class="col-form-label" for="commissionProfileDesc">Commission Profile Description <span aria-hidden="true"
                                  class="symbol required" style="color:red;">*</span>
                          </label>
                          <input type="text" id="commissionProfileDesc" [readonly]="!permissions.includes('Edit')" class="form-control" required formControlName="commissionProfileDesc" (paste)="onPaste($event)"  (keypress)="OnlyCharacterAllowed($event)" placeholder="Enter Commission Profile Description" [ngClass]="{'is-invalid':submitted && editCommissionProfileForm.controls.commissionProfileDesc.errors}"  name="commissionProfileDesc">
                          <div class="invalid-feedback" >
                            <div >
                                Commission Profile Description is required.
                            </div>
                        </div>
                        </div>
                        <div class="form-group col-md-4">
                            <label class="col-form-label" for="country">Country<span aria-hidden="true"
                                    class="symbol required" style="color:red;">*</span>
                            </label>
                            <input type="text" id="country" readonly class="form-control" required formControlName="country" [ngClass]="{'is-invalid':submitted && editCommissionProfileForm.controls.country.errors}"  name="country">
                        </div>        
                      </div>
                      <div class="row d-flex">
                        <div class="form-group col-md-4">
                            <label class="col-form-label" for="product">Product<span aria-hidden="true"
                                    class="symbol required" style="color:red;">*</span>
                            </label>
                            <input type="text" id="product" readonly class="form-control" required formControlName="product"  [ngClass]="{'is-invalid':submitted && editCommissionProfileForm.controls.product.errors}"  name="product">
                        </div> 
                        <div class="form-group col-md-4">
                            <label class="col-form-label" for="serviceProvider">Service Provider<span aria-hidden="true"
                                    class="symbol required" style="color:red;">*</span>
                            </label>
                            <input type="text" id="serviceProvider" readonly class="form-control" required formControlName="serviceProvider"  [ngClass]="{'is-invalid':submitted && editCommissionProfileForm.controls.serviceProvider.errors}"  name="serviceProvider">
                        </div> 
                        <div class="form-group col-md-4">
                            <label class="col-form-label" for="maxBalance">Maximum Balance <span aria-hidden="true"
                                    class="symbol required" style="color:red;">*</span>
                            </label>
                            <input type="text" id="maxBalance" readonly maxlength="8" class="form-control" required formControlName="maxBalance" placeholder="Maximum Balance" [ngClass]="{'is-invalid':submitted && editCommissionProfileForm.controls.maxBalance.errors}">
                        </div>
                    </div>  
                    <div class="row d-flex">
                        <div class="form-group col-md-4">
                            <label class="col-form-label" for="status">Status<span aria-hidden="true"
                                    class="symbol required" style="color:red;">*</span>
                            </label>
                            <input type="text" id="status" readonly class="form-control" required formControlName="status"  [ngClass]="{'is-invalid':submitted && editCommissionProfileForm.controls.status.errors}"  name="status">
                        </div> 
                    </div>     
                    <br>
                      <div class="row">
                          <div class="form-group col-md-12 text-right">
                              <button type="submit" *ngIf="permissions.includes('Edit')" class="btn btn-primary">Save & Next</button>
                              <button type="button" *ngIf="!permissions.includes('Edit')" (click)="switchTab('commission')" class="btn btn-primary">Next</button>
                              <button type="button" class="btn btn-secondary" id="cancelButton" (click)="cancelButton()">Cancel</button>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> 
            </form>
         </div>
         <div id="commission" class="tab-pane fade p-4 active show" [ngStyle]="{ 'display': activeTab === 'commission'? 'block' : 'none'}">
            <div class="row">
                <div class="col-lg-12">
                  <div class="card border-0 shadow-none text-center">
                    <div class="card-body">
                      <div class="row d-flex">
                        <div class="form-group col-md-3 ">
                            <label class="col-form-label">Product Name</label>
                            <input type="text" id="productName" readonly value="{{productName}}" class="form-control">
                        </div>
                        <div class="form-group col-md-3 ">
                            <label class="col-form-label">Country</label>
                            <input type="text" id="category" readonly value="{{countryName}}" class="form-control">
                        </div>
                        <div class="form-group col-md-3 ">
                            <label class="col-form-label">Service Provider</label> 
                            <input type="text"  id="subCategory" readonly value="{{serviceProviderName}}" class="form-control">
                        </div>
                      </div>
                      <div class="row d-flex">
                        <div class="text-right">
                          <button type="button" class="btn btn-primary" *ngIf="permissions.includes('Approve')" (click)="reviewSlab($event)" >Review</button>
                          <button type="button" class="btn btn-primary" *ngIf="permissions.includes('Edit') && showCopyButton" (click)="copySlab()" ><i class="feather icon-copy"></i> Copy</button>
                          <button type="button" class="btn btn-primary" *ngIf="permissions.includes('Edit')" (click)="addNewSet()" >New Slab</button>
                        </div>
                      </div>
                      <br>
                    <div class="row d-flex" *ngIf="savedSlabDataTable" style="min-height: 270px">
                        <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
                          <ag-grid-angular [enableCellTextSelection]=true (gridReady)="onGridReady($event)" 
                            [columnDefs]="savedDatatableColumn" [defaultColDef]="defaultColDef" [enableCellTextSelection]=true
                             [rowData]="savedSlabData" [rowModelType]="" [rowSelection]="'single'"
                            [suppressPaginationPanel]="true" style="width: 100%; height: auto;">
                          </ag-grid-angular>
                        </div>
                    </div>
                    <hr>
                    <div class="row d-flex" *ngIf="showDataTable">
                      <div class="text-right">
                            <button type="button" class="btn btn-primary" (click)="addRow()"><i class="feather icon-plus-circle"></i> Add Row</button>
                            <button type="button" class="btn btn-secondary" id="cancelButton" (click)="clearButton()">Clear</button>
                      </div>  
                    </div>
                    <br>
                    <div class="row d-flex" *ngIf="showDataTable" style="min-height: 270px">
                        <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
                          <ag-grid-angular [enableCellTextSelection]=true (gridReady)="onGridReady($event)" 
                            [columnDefs]="tableSelectedColumn" [defaultColDef]="defaultColDef" [enableCellTextSelection]=true
                             [rowData]="finalCommissionData" [rowModelType]="" [rowSelection]="'single'"
                            [suppressPaginationPanel]="true" style="width: 100%; height: auto;">
                          </ag-grid-angular>
                        </div>
                    </div>
                    <br>
                    <div class="row d-flex">
                      <div class="form-group col-md-9"></div>
                      <div class="form-group col-md-3 text-right">
                        <button type="button" class="btn btn-secondary" id="cancelButton" (click)="switchTab('service')">Back</button>
                        <button type="button" class="btn btn-primary" (click)="updateCommissionSlab()" *ngIf="showDataTable && permissions.includes('Add')" >Save</button>
                        <button type="button" class="btn btn-danger" id="cancelButton" (click)="cancelButton()">Cancel</button>
                      </div>
                    </div>

                  </div>
                </div>
              </div> 
         </div>
    </div>  
</div>

<app-modal #openReviewSlab [modalConfig]="modalSlabReview" style="width: 1200px;">

  <h4 class="text-center">Review Changes</h4>
  <div *ngIf="showOldSlab">
    <br>
    <br>
    <h5>Old Slab</h5>
    <div class="row d-flex">
      <div class="form-group col-md-12 ">
        <div class="row mb-0" style="min-height: 270px">
          <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
            <ag-grid-angular [enableCellTextSelection]=true (gridReady)="onGridReady($event)"
              [columnDefs]="savedDatatableColumn" [defaultColDef]="defaultColDef" [enableCellTextSelection]=true
              [rowData]="oldSlab" [rowModelType]="" [rowSelection]="'single'" [suppressPaginationPanel]="true"
              style="width: 100%; height: auto;">
            </ag-grid-angular>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="showNewSlab">
    <br>
    <br>
    <h5>New Slab</h5>
    <div class="row d-flex">
      <div class="form-group col-md-12 ">
        <div class="row mb-0" style="min-height: 270px">
          <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
            <ag-grid-angular [enableCellTextSelection]=true (gridReady)="onGridReady($event)"
              [columnDefs]="savedDatatableColumn" [defaultColDef]="defaultColDef" [enableCellTextSelection]=true
              [rowData]="newSlab" [rowModelType]="" [rowSelection]="'single'" [suppressPaginationPanel]="true"
              style="width: 100%; height: auto;">
            </ag-grid-angular>
          </div>
        </div>
      </div>
    </div>
  </div>

    <div class="form-group col-md-12">
      <div class="text-center">
        <input type="text" autocomplete="off" id="inputBorder" placeholder="Enter the Remark"
          [(ngModel)]="slabRemarks">
      </div>
    </div>



  <div class="row d-flex">
    <div class="form-group col-md-12 text-center">
      <button type="button" class="btn btn-primary" (click)="slabStatusChange('ACTIVE')">Approve</button>
      <button type="button" class="btn btn-secondary" id="cancelButton"
        (click)="slabStatusChange('REJECTED')">Reject</button>
    </div>
  </div>

</app-modal>